import { Subject } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class LaddaService {
  private laddaSubject = new Subject<LaddaState>();
  laddaState = this.laddaSubject.asObservable();

  constructor() { }

  show() {
      this.laddaSubject.next(<LaddaState>{show: true});
  }

  hide() {
      this.laddaSubject.next(<LaddaState>{show: false});
  }
}

export interface LaddaState {
  show: boolean;
}
